import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { DataTable } from '../../../components'
import { useMessage, useModalDialog } from '../../../hooks'
import { useClientCaseDialog } from '../hooks'
import { clientCaseService } from '../services'
import { appName } from '../appConfig'
import '../index.css'

const LANG_VALUES = {
  sv:   { label: 'SV',   className: 'pill' },
  en:   { label: 'EN',   className: 'pill' },
  both: { label: 'BOTH', className: 'pill' },
}

const STATUS_VALUES = {
  published: { label: 'Publicerad',   className: 'pill pill-green' },
  draft:     { label: 'Ej genererad', className: 'pill pill-grey' },
}

// client_name/client_slug are joined from clients.client + network.company
// server-side (see ClientCase.js) — the JSONB no longer carries client identity.
const flatten = (c) => ({
  ...c,
  start:       c.client_case_data?.engagement?.start || '—',
  status_value: c.has_html ? 'published' : 'draft',
  updated:     c.modified_timestamp || c.created_timestamp,
  visa_path:   c.has_html ? c.client_case_slug : `${c.client_case_slug}/edit`,
})

const ClientCaseList = () => {
  const navigate = useNavigate()
  const { showMessage } = useMessage()
  const { hideModalDialog } = useModalDialog()
  const { showDeleteClientCaseDialog } = useClientCaseDialog()

  const [cases, setCases] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [loading, setLoading] = useState(true)

  const fetchCases = () => {
    clientCaseService.getAll()
      .then(res => { setCases((res.clientCases || []).map(flatten)); setLoading(false) })
      .catch(() => { showMessage('Kunde inte ladda kundcase', 'error'); setLoading(false) })
  }

  useEffect(() => {
    fetchCases()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const deleteCase = (items) => {
    const c = items[0]
    showDeleteClientCaseDialog({ client_name: c.client_name, slug: c.client_case_slug }, async () => {
      await clientCaseService.remove(c.client_case_uuid)
        .then(() => { hideModalDialog(); showMessage('Borttagen'); setSelectedItems([]); fetchCases() })
        .catch(err => showMessage(err.message || 'Kunde inte ta bort', 'error'))
    })
  }

  return (
    <div className="ClientCaseList wide-margin">
      <DataTable
        data={cases}
        idColumn="client_case_uuid"
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        loading={loading}
        filterable
        filterObjects={['client_name', 'client_case_slug', 'client_case_lang']}
        columns={[
          { id: 'client_case_slug', name: 'Visa',         type: 'button', label: 'Visa', data: { data: 'visa_path' },
            onClick: (path) => navigate(`/${appName}/cases/${path}`) },
          { id: 'client_name',   name: 'Kund',           className: 'bold' },
          { id: 'start',         name: 'Start' },
          { id: 'status_value',  name: 'Status',         type: 'pill', value: 'status_value',     values: STATUS_VALUES },
          { id: 'client_case_lang', name: 'Språk',        type: 'pill', value: 'client_case_lang', values: LANG_VALUES },
          { id: 'updated',       name: 'Uppdaterad',     type: 'datetime' },
        ]}
        buttons={[
          { label: '+ Nytt case', action: 'add', mainButton: true, onClick: () => navigate(`/${appName}/cases/new`) },
          { label: 'Redigera', action: 'edit', onClick: (items) => navigate(`/${appName}/cases/${items[0].client_case_slug}/edit`) },
          { label: 'Ta bort', action: 'delete', onClick: deleteCase },
        ]}
      />
    </div>
  )
}

export default ClientCaseList
